/** CRM → Entrance Exam / FIS Exam (Phase 93). Amounts come straight from
 * the student's Payment Checklist on the backend; paidAmount counts
 * confirmed (approved) payments only. */
export type ExamFeeStatus = 'UNPAID' | 'PARTIALLY_PAID' | 'PENDING_CONFIRMATION' | 'PAID';

export interface ExamFeeSummary {
  name: string;
  status: ExamFeeStatus;
  requiredAmount: number | null;
  paidAmount: number;
  outstandingAmount: number | null;
  hasPendingPayment: boolean;
  currency: { code: string; symbol: string | null } | null;
}

interface PersonRef {
  id: number;
  firstName: string;
  lastName: string;
}

export interface ExamStudentRow {
  id: number;
  studentId: number;
  student: {
    id: number;
    studentNumber: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string | null;
  };
  branch: { id: number; name: string } | null;
  counselor: PersonRef;
  university: { id: number; name: string } | null;
  course: { id: number; name: string; isFoundationExam: boolean } | null;
  intake: { id: number; name: string } | null;
}

export type HandlingFeeFilter = 'ALL' | 'FULLY_PAID' | 'PARTIALLY_PAID';

export interface EntranceExamStudent extends ExamStudentRow {
  registrationFee: ExamFeeSummary;
  handlingFee: ExamFeeSummary;
  handlingFeeStatus: 'FULLY_PAID' | 'PARTIALLY_PAID';
}

export const FIS_EXAM_STATUSES = [
  'REGISTERED',
  'SAT',
  'PASSED',
  'FAILED',
  'ABSENT',
  'WITHDRAWN',
] as const;
export type FisExamStatus = (typeof FIS_EXAM_STATUSES)[number];

export interface FisExamRegistration {
  id: number;
  studentId: number;
  status: FisExamStatus;
  examDate: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  registeredBy: PersonRef;
  updatedBy: PersonRef | null;
}

export interface FisExamStudent extends ExamStudentRow {
  fisExamFee: ExamFeeSummary | null;
  registration: FisExamRegistration | null;
}

export type FisRegistrationFilter = 'ALL' | 'NOT_REGISTERED' | FisExamStatus;
export type FisFeeFilter = 'ALL' | 'PAID' | 'NOT_PAID';

export interface FisExamRegistrationInput {
  status: FisExamStatus;
  examDate?: string | null;
  notes?: string | null;
}
